
import QUESTIONNAIRE_DE from "./de"
import QUESTIONNAIRE_EN from "./en"

export const QUESTIONNAIRE = {
  de: QUESTIONNAIRE_DE,
  en: QUESTIONNAIRE_EN
}